export default "__VITE_ASSET__BhHT33Z6__"